<template>
    <app-layout>
        <div class="flex justify-center pt-8 sm:justify-start sm:pt-0">
            <Link :href="route('snail::levels.index')">
                <img style="filter: drop-shadow(0px 0px 20px rgb(0, 135, 255));" src="../../assets/Snaillogo.png" class="w-1/4" alt="logo"/>
            </Link>
        </div>
        <slot/>
        <template #footer>
            <div class="text-center text-sm text-gray-500 sm:text-left">
                <div class="flex items-center">
                    Crafted with
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" class="mx-1 -mt-px w-4 h-4 text-red-500">
                        <path
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                    </svg>
                    By
                    <a href="https://bird.cafe" class="ml-1 underline">Bird Cafe</a>
                    <span>&nbsp;|&nbsp;</span>
                    <a href="https://patreon.com/seebeyond" class="underline" style="color:#FF424D;">Support us on Patreon!</a>
                    <span>&nbsp;|&nbsp;</span>
                    <Link href="/" class="underline">Home Page</Link>
                </div>
            </div>
            <div class="ml-4 text-center text-sm text-gray-500 sm:text-right sm:ml-0">
                Not affiliated with <a class="underline" href="https://twitter.com/JonasTyroller">Jonas Tyroller</a> or <a class="underline" href="https://store.steampowered.com/app/1115050/Will_You_Snail/">Will You Snail?</a>
            </div>
        </template>
    </app-layout>
</template>
<script>
import AppLayout from "@/Layouts/App";
import {Head as DocumentHead, Link} from "@inertiajs/inertia-vue3";
import BreezeDropdown from "@/Components/Dropdown";
import BreezeDropdownLink from "@/Components/DropdownLink";

export default {
    components: {
        AppLayout,
        DocumentHead,
        Link,
        BreezeDropdown,
        BreezeDropdownLink,
    },
    props: {
        auth: Object,
        level: Object,
    },

    methods: {
        highlight(e, copy = false) {
            let selection = window.getSelection();
            let range = document.createRange();
            range.selectNodeContents(e);
            selection.removeAllRanges();
            selection.addRange(range);
            if (copy) {
                navigator.clipboard.writeText();
            }
        }
    }
}
</script>
